var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_3120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.14867 12.436L6.742 14.842C5.198 16.3853 2.7 16.3853 1.15667 14.842C0.41 14.0967 0 13.1047 0 12.05C0 10.9953 0.41 10.0033 1.156 9.25733L4.4 6.014C5.97 4.444 8.476 4.506 9.98467 6.014C10.2867 6.316 10.5247 6.66267 10.7107 7.032L9.64867 8.09333C9.52867 7.68467 9.31533 7.30067 9.006 6.992C8.04067 6.02667 6.386 5.98533 5.38 6.99133L5.37933 6.99267L2.13467 10.236C1.13467 11.2353 1.13467 12.8633 2.13467 13.8627C3.146 14.874 4.77333 14.8547 5.76267 13.8627L7.37933 12.2467C8.04133 12.436 8.57333 12.47 9.14867 12.436ZM9.256 1.15733L6.87333 3.54133C7.438 3.508 7.97667 3.54133 8.642 3.73L10.2373 2.13733C11.236 1.136 12.864 1.13733 13.864 2.13667C14.8753 3.14867 14.8547 4.776 13.864 5.76467L10.6433 8.98533L10.6413 8.98667C9.68267 9.94467 8.05067 10.0213 7.01533 8.98533C6.7 8.66933 6.492 8.29067 6.378 7.89L6.322 7.93533L5.31067 8.94533C5.49733 9.316 5.734 9.662 6.036 9.964C7.53267 11.4607 10.0387 11.5467 11.6213 9.964L14.8427 6.74333C16.3853 5.19933 16.3867 2.702 14.842 1.15867C13.2973 -0.388666 10.7973 -0.383333 9.256 1.15733Z",
    fill: "#1B4022"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_3120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.5cdccb45.svg";
export { ForwardRef as ReactComponent };